// @flow

// https://stackoverflow.com/questions/11381673/detecting-a-mobile-browser
export const getIsAndroidDevice = (
  userAgentString?: string = navigator.userAgent,
) => {
  if (!userAgentString) {
    throw new Error('window.navigator.userAgent is undefined');
  }

  return !!userAgentString.match(/Android/i);
};
